export default __webpack_public_path__ + "static/alumni-testimonials-96ec15df06c5e361b66ed8b89e53d570.svg";